import { BookOpen, ChartNoAxesColumn, CirclePlus, House, UserRound } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";

const items = [
  { to: "/", label: "今天", icon: House, end: true },
  { to: "/homeworks", label: "作业", icon: BookOpen },
  { to: "/capture", label: "录入", icon: CirclePlus, primary: true },
  { to: "/report", label: "报告", icon: ChartNoAxesColumn },
  { to: "/profile", label: "我的", icon: UserRound },
];

export function AppShell() {
  return (
    <div className="app-shell">
      <main className="app-main">
        <Outlet />
      </main>
      <nav className="bottom-nav" aria-label="主导航">
        {items.map(({ to, label, icon: Icon, end, primary }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className={primary ? "nav-primary" : "nav-icon"}>
              <Icon size={primary ? 30 : 23} strokeWidth={primary ? 2.2 : 1.9} aria-hidden="true" />
            </span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
